import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.35_@babel+core@7.28.4_@opentelemetry+api@1.9.0_@playwright+test@1.56.0_babel-plugin_x3zc7rf37pw2rnre624clzj43y/node_modules/next/dist/client/script.js");
